<script setup lang="ts">
import type { Envelope } from '@/stores/useEnvelopeStore'

const props = defineProps<{ params: { data: Envelope } }>()
const sales = props.params.data.quote?.salesEngineer ?? null

const fullName = sales
  ? `${sales.firstName || ''} ${sales.lastName || ''}`.trim() || sales.email || '-'
  : '-'
</script>

<template>
  <span class="text-sm" :class="{ 'text-gray-400': fullName === '-' }">{{ fullName }}</span>
</template>
